export class SoloareDeliveryUpdateResponse {
    result: String;

    constructor(
        result: String
    ) {
        this.result = result;
    }
}
